'use es6';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import { makeGetCellOrRowParentId, makeGetCanCellBeCloned, getLayoutSectionTreeById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { dragTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { draggingStartedAndDeselectExisting as draggingStartedAndDeselectExistingAction, draggingStoppedAndReselectIfNeeded as draggingStoppedAndReselectIfNeededAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { buildActionsForColumn, BaseResponsiveColumnToolbar } from './BaseResponsiveColumnToolbar';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getIsInDeveloperMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { useToggleNodeVisibilityOnThisBreakpoint } from 'ContentEditorUI/components/sidebar/contentTree/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const getCellById = (tree, id) => {
  if (tree && tree.hasCell(id)) {
    return tree.findCell(id);
  }
  return null;
};
const dragSource = {
  beginDrag(props) {
    const {
      id,
      parentId,
      draggingStartedAndDeselectExisting,
      layoutSectionId
    } = props;
    const dragItem = {
      dragId: id,
      dragParentId: parentId,
      isColumn: true,
      isRow: false,
      isTopMostRow: false,
      originLayoutSectionId: layoutSectionId
    };
    draggingStartedAndDeselectExisting(dragItem);
    return dragItem;
  },
  canDrag(props) {
    return props.isInDefaultBreakpointMode;
  },
  endDrag(props, monitor) {
    const {
      draggingStoppedAndReselectIfNeeded
    } = props;
    draggingStoppedAndReselectIfNeeded(monitor.getItem(), monitor.didDrop());
  }
};
function dragCollect(dndConnect, monitor) {
  return {
    connectDragPreview: dndConnect.dragPreview(),
    connectDragSource: dndConnect.dragSource(),
    isDragging: monitor.isDragging()
  };
}
const mapStateToProps = () => {
  const getCellOrRowParentId = makeGetCellOrRowParentId();
  const getCanCellBeCloned = makeGetCanCellBeCloned();
  return (state, ownProps) => {
    if (ownProps.id) {
      return {
        parentId: getCellOrRowParentId(state, {
          layoutSectionId: ownProps.layoutSectionId,
          id: ownProps.id
        }),
        isInDefaultBreakpointMode: getIsInDefaultBreakpointMode(state),
        canBeCloned: getCanCellBeCloned(state, {
          layoutSectionId: ownProps.layoutSectionId,
          id: ownProps.id
        }),
        isInDeveloperMode: getIsInDeveloperMode(state),
        selectedItemId: getSelectedItemId(state),
        layoutSectionTree: getLayoutSectionTreeById(state, {
          layoutSectionId: ownProps.layoutSectionId
        })
      };
    }
    return {};
  };
};
const mapDispatchToProps = {
  draggingStartedAndDeselectExisting: draggingStartedAndDeselectExistingAction,
  draggingStoppedAndReselectIfNeeded: draggingStoppedAndReselectIfNeededAction
};
const ResponsiveColumnToolbarComponent = ({
  id,
  layoutSectionId,
  active,
  top,
  left,
  onHandleMouseDown,
  onDropdownOpenChange,
  responsiveSize = DEFAULT_RESPONSIVE_SIZE,
  connectDragPreview,
  connectDragSource,
  dispatch,
  bus,
  isInDefaultBreakpointMode,
  canBeCloned,
  isInDeveloperMode,
  selectedItemId,
  layoutSectionTree
}) => {
  const treeNode = layoutSectionTree ? getCellById(layoutSectionTree, id) : null;
  const toggleNodeVisibilityOnThisBreakpoint = useToggleNodeVisibilityOnThisBreakpoint(treeNode);
  useEffect(() => {
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [connectDragPreview]);
  return /*#__PURE__*/_jsx(BaseResponsiveColumnToolbar, {
    active: active,
    actions: buildActionsForColumn({
      columnName: id,
      layoutSectionId,
      isInDefaultBreakpointMode,
      canBeCloned,
      dispatch,
      bus,
      isInDeveloperMode,
      toggleNodeVisibilityOnThisBreakpoint
    }),
    style: {
      top,
      left
    },
    responsiveSize: responsiveSize,
    onHandleMouseDown: onHandleMouseDown,
    onDropdownOpenChange: onDropdownOpenChange,
    connectDragSource: connectDragSource,
    showHandleGrippie: false,
    isSelectedItem: id === selectedItemId
  });
};
ResponsiveColumnToolbarComponent.propTypes = {
  id: PropTypes.string,
  layoutSectionId: PropTypes.string,
  active: PropTypes.bool.isRequired,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  onHandleMouseDown: PropTypes.func,
  onDropdownOpenChange: PropTypes.func,
  responsiveSize: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  draggingStartedAndDeselectExisting: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  draggingStoppedAndReselectIfNeeded: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  bus: PropTypes.object.isRequired,
  isInDefaultBreakpointMode: PropTypes.bool,
  canBeCloned: PropTypes.bool,
  isInDeveloperMode: PropTypes.bool,
  selectedItemId: PropTypes.string,
  layoutSectionTree: PropTypes.object
};
export default connect(mapStateToProps, mapDispatchToProps)(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(ResponsiveColumnToolbarComponent));